import React, { useEffect, useRef } from 'react';
import { initializeCesium } from '../cesium';

function Cesium() {
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      // Initialize Cesium without any interactive options
        initializeCesium();
        initialized.current = true;
    }
  }, []);

  return <div id="cesiumContainer" className="w-full h-full" />;
}

export default Cesium; 